export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/70f493da8594d48e981e492e7ad165cc.jpg"
          alt="VPN Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-3">
            <h1 className="text-6xl lg:text-7xl font-bold text-white mb-6 tracking-tight leading-tight">
              <span className="block text-7xl lg:text-8xl">Secure</span>
              <span className="block text-5xl lg:text-6xl">Your Digital</span>
              <span className="block text-7xl lg:text-8xl">Freedom</span>
            </h1>
            <p className="text-xl text-gray-300 mb-12 max-w-xl">
              Enterprise-grade VPN protection for your privacy
            </p>
            <div className="flex flex-wrap gap-5">
              <button
                onClick={() => scrollToSection('contact')}
                className="px-10 py-4 bg-blue-600 text-white text-base font-semibold rounded-full hover:bg-blue-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                Get Started Free
              </button>
              <button
                onClick={() => scrollToSection('features')}
                className="px-10 py-4 bg-transparent text-white text-base font-semibold rounded-full border-2 border-white hover:bg-white hover:text-gray-900 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>

          <div className="lg:col-span-2 relative">
            <div className="relative w-full max-w-md mx-auto">
              <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-3xl"></div>
              <div className="relative transform rotate-12 hover:rotate-0 transition-transform duration-500">
                <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-3xl p-8 shadow-2xl border border-gray-700">
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 rounded-full bg-red-500"></div>
                      <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
                      <div className="w-3 h-3 rounded-full bg-green-500"></div>
                    </div>
                  </div>
                  <div className="space-y-6">
                    <div className="text-center">
                      <div className="w-24 h-24 mx-auto mb-4 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center animate-pulse">
                        <i className="ri-shield-check-line text-4xl text-white"></i>
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-2">Connected</h3>
                      <p className="text-green-400 text-sm font-medium">Your connection is secure</p>
                    </div>
                    <div className="bg-gray-800/50 rounded-xl p-4 space-y-3">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-400 text-sm">Location</span>
                        <span className="text-white font-medium text-sm">Brazil</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-400 text-sm">IP Address</span>
                        <span className="text-white font-medium text-sm">Protected</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span className="text-gray-400 text-sm">Protocol</span>
                        <span className="text-white font-medium text-sm">OpenVPN</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="absolute -top-8 -left-8 w-32 h-32 rounded-full bg-white/10 backdrop-blur-sm"></div>
              <div className="absolute -bottom-8 -right-8 w-40 h-40 rounded-2xl bg-white/5 backdrop-blur-sm"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
